import React from 'react'
import styled from 'styled-components'
import {
  Box,
  getPaletteColor,
  Button,
  Text,
  Link,
  Container,
  theme
} from 'pcln-design-system'
import { Map } from 'pcln-icons'
import Banner from '@pcln/banners'

const Wrapper = styled.div`
  background-color: ${theme.colors.lightGray};
  padding: 16px 0;
`
const InnerWrapper = styled.div`
  margin: 0 16px;
  max-width: 810px;
  ${props => props.theme.mediaQueries[0]} {
    margin: 0 28px;
  }
`
const IconWrapper = styled(Box)`
  border-radius: 50%;
  font-size: 0;
  background-color: ${getPaletteColor('primary.light')};
`

export default function FindMyTripBanner({
  isMobile = false
}: {
  isMobile?: boolean
}) {
  const linkText = isMobile ? 'Find Trip' : 'Find your Trip'
  const headingText = isMobile
    ? 'Looking for trip details?'
    : 'Looking for your trip details?'

  return (
    <Wrapper>
      <Container>
        <InnerWrapper>
          <Banner
            borderHugTop="primary.base"
            outline="border.base"
            iconLeft={
              <IconWrapper p={2} ml={3} mr={2}>
                <Map color="primary.base" size="25px" />
              </IconWrapper>
            }
            heading={
              <Text fontSize={1} pb={1} color="primary.base">
                {headingText}
              </Text>
            }
            text={
              <Text fontSize={0}>
                Quickly find your flight, hotel, package or rental car
                reservation
              </Text>
            }
            buttonRight={
              <Box minWidth="80px">
                <Link href="/next-profile/trip-lookup">
                  <Button size="small" data-testid="FIND_MY_TRIP_BUTTON">
                    {linkText}
                  </Button>
                </Link>
              </Box>
            }
          />
        </InnerWrapper>
      </Container>
    </Wrapper>
  )
}
